//Include Both Helper File with needed methods
import {
  postSalesRegisterFormData,
  postJwtRegister,
  postInvestRegisterFormData,
} from "../../../helpers/ServiceHelpers/backend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  registerInvestUserSuccessful,
  registerInvestUserFailed,
  // apiErrorChange
} from "./reducer";
import { checkEmailExist as checkEmailExistApi } from "../../../helpers/ServiceHelpers/backend_helper";

// Is user register successfull then direct plot user in redux.
export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtRegister("/post-jwt-register", user);
      // yield put(registerUserSuccessful(response));
    } else if (process.env.REACT_APP_API_URL) {
      response = postSalesRegisterFormData(user);
      const data: any = await response;

      if (data.resultType === 1) {
        dispatch(registerUserSuccessful(data));
      } else {
        dispatch(registerUserFailed(data));
      }
      return data;
    }
  } catch (error) {
    dispatch(registerUserFailed(error));
  }
};

export const registerInvestUser = (user: any) => async (dispatch: any) => {
  try {
    let response;

    if (process.env.REACT_APP_API_URL) {
      response = postInvestRegisterFormData(user);
      const data: any = await response;

      if (data.resultType === 1) {
        dispatch(registerInvestUserSuccessful(data));
      } else {
        dispatch(registerInvestUserFailed(data));
      }
      return data;
    }
  } catch (error) {
    dispatch(registerInvestUserFailed(error));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

// Get Check Email Exist
export const checkEmailExist = createAsyncThunk(
  "get/CheckEmailExist",
  async (email: string) => {
    try {
      const response = checkEmailExistApi(email);
      return response;
    } catch (error) {
      return error;
    }
  }
);
